import React from 'react';
import styled from 'styled-components';

interface ProgressBarProps {
  percent: number;
  color?: string;
  height?: number;
  label?: string;
  showValue?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  percent,
  color,
  height = 6,
  label,
  showValue = false
}) => {
  const clampedPercent = Math.min(100, Math.max(0, percent));
  const resolvedColor = color || getAutoColor(clampedPercent);

  return (
    <Wrapper>
      {label && <Label>{label}</Label>}
      <BarOuter $height={height}>
        <BarFill
          style={{ width: `${clampedPercent}%`, background: resolvedColor }}
        />
      </BarOuter>
      {showValue && <Value>{Math.round(clampedPercent)}%</Value>}
    </Wrapper>
  );
};

const getAutoColor = (percent: number): string => {
  if (percent >= 75) return 'var(--olive)';
  if (percent >= 50) return 'var(--amber)';
  return 'var(--crimson)';
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const Label = styled.span`
  font-size: 12px;
  color: var(--ink-muted);
  white-space: nowrap;
  flex-shrink: 0;
`;

const BarOuter = styled.div<{ $height: number }>`
  flex: 1;
  height: ${({ $height }) => $height}px;
  background: var(--paper);
  border-radius: 100px;
  overflow: hidden;
  min-width: 40px;
`;

const BarFill = styled.div`
  height: 100%;
  border-radius: 100px;
  transition: width 0.3s ease;
`;

const Value = styled.span`
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  color: var(--ink-muted);
  flex-shrink: 0;
  min-width: 32px;
  text-align: right;
`;
